import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { disableScroll, enableScroll } from '../helper/scroll';
import { throttle } from 'throttle-debounce';
import { power5 } from '../helper/easing';
power5;

const nav = {
	init() {

		/* 
		!!!!!!!!!!
		!!!!!!!!!!
		Header scroll
		!!!!!!!!!!
		!!!!!!!!!!
		*/
		let lastKnownScrollPosition = 0;
		let ticking = false;
		const header = document.querySelector('.k-header');		

		function headerClass(scrollPos) {
			if (lastKnownScrollPosition >= "120") {
				header.classList.add('scrolled');
			} else {
				header.classList.remove('scrolled');
			}
		}

		headerClass(window.scrollY);

		document.addEventListener("scroll", function(e) {
			throttleScroll(1);
		});		
		const throttleScroll = throttle(1000, (num) => {
			lastKnownScrollPosition = window.scrollY;
			if (!ticking) {
				window.requestAnimationFrame(function() {
					headerClass(lastKnownScrollPosition);
					ticking = false;
				});

				ticking = true;
			}			
		});				

		/* 
		!!!!!!!!!!
		!!!!!!!!!!
		Burger menu
		!!!!!!!!!!
		!!!!!!!!!!
		*/

		const burgerNav = document.querySelector('.k-header .js-burger');
		async function aniMenuPrep() {
			let navLines1 = new SplitText('.k-header .primary-nav .js-split-lines', {
				type: 'lines',
				linesClass: 'js-line'
			});      
			let navLines2 = new SplitText('.k-header .primary-nav .js-split-lines', {
				type: 'lines',
				linesClass: 'js-line-wrapper'
			});                  			
		}
		
		aniMenuPrep().then(() => {		
			burgerNav.addEventListener('click', () => {
				if (document.querySelector('body').classList.contains('primary-nav-active')){
					document.querySelector('body').classList.remove('primary-nav-active');
					aniBurger(true);
					aniMenu(true);
					enableScroll();
				} else {
					document.querySelector('body').classList.add('primary-nav-active');
					aniBurger();
					aniMenu();
					disableScroll();
				}
			});
		});

		const aniMenu = (reverse) => {
			
			const menu = document.querySelector('.k-header .js-nav-burger');
			const menuItems = menu.querySelectorAll('.primary-nav .js-split-lines .js-line');
			const navProject = menu.querySelector('.js-nav-project > *');
			const projectCopy = menu.querySelectorAll('.js-nav-project .js-nav-project-copy');
			const tlOpen = gsap.timeline({paused: true});
			const tlClose = gsap.timeline({paused: true});

			tlOpen
			.set(navProject, {'clip-path': 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)'}, 0)
			.set(menuItems, {y: '110%'}, 0)
			.set(menu, {display: 'flex'}, 0)
			.set(projectCopy, {opacity: 0}, 0)
			.fromTo(menu, 0.4, {
				x: '100%',
			},
			{
				x: '0%',
				ease: 'power3.out',
			}, 0)
			.fromTo(menuItems, 1, {
				y: '110%',
			},
			{
				y: '0',
				ease: 'power3.out',
				stagger: 0.2,
			}, 0.5)
			.fromTo(navProject, 0.6, {
				'clip-path': 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
			},
			{
				'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
				ease: 'power3.inOut',
			}, 0.25)
			.fromTo(projectCopy, 0.6, {
				opacity: 0,
				x: 20,
			},
			{
				opacity: 1,
				x: 0,
				ease: 'power3.out',
			}, ">-=0.1")			
			;

			tlClose
			.set(navProject, {'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'}, 0)
			.set(menuItems, {y: '0%'}, 0)
			.set(projectCopy, {opacity: 1, x: 0}, 0)
			.fromTo(projectCopy, 0.3, {
				opacity: 1,
			},
			{
				opacity: 0,
			})			
			.fromTo(menu, 0.15, {
				x: '0%',
			},
			{
				x: '100%',
				ease: 'power3.in',
			}, 0)
			.fromTo(menuItems, 0.2, {
				y: '0',
			},
			{
				y: '110%',
				ease: 'power3.in',
			}, 0)
			.fromTo(navProject, 0.3, {
				'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
			},
			{
				'clip-path': 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
				ease: 'power3.in',
				immediateRender: true,
			}, 0)
			.set(menu, {display: 'none'})
			;			

			if (reverse == true){				
				tlClose.play(0);
			} else {
				tlOpen.play(0);
			}			

		}		
		

		const aniBurger = (reverse) => {
    
			if (document.querySelectorAll('.icon-burger').length > 0) {				
						
				const   burger = document.querySelector('.k-header .icon-burger'),
						burgerDLine = burger.querySelector('.d-lines line'),
						burgerCircle = document.querySelector('.k-header .icon-burger-circle'),
						circle = burgerCircle.querySelector('.circle'),
						burgerCircleLength = Math.ceil(circle.getTotalLength()),
						burgerLineLength = Math.ceil(burgerDLine.getTotalLength());

				const   tl = gsap.timeline({paused: true}),
						hLines = burger.querySelectorAll(".h-lines line"),
						dLines = burger.querySelectorAll(".d-lines line"),
						stagger = 0.2,
						dStart = 0.55,
						duration = 0.1;
	
				tl
				.set(dLines, {strokeDashoffset:burgerLineLength+'px'})
				.set(circle, {strokeDasharray: burgerCircleLength+'px', opacity: 1})
				.set(burgerCircle, {transformOrigin:'center'})
				.set(dLines, {strokeDasharray: burgerLineLength+'px'})
				.set(dLines, {opacity: 1})
				.staggerFromTo(
					hLines,
					duration,
					{
						scaleX: 1,
						x: 0,
						transformOrigin:"100% 0%",
					},
					{
						scaleX: 0,
						x: 12,
						transformOrigin:"100% 0%",
						ease: "power5.in",						
					},
				stagger, 0)
				.fromTo(
					burgerCircle,
					duration*8,
					{						
						rotation: '-180deg',
					},
					{
						rotation: '0deg',
						ease: "expo.out",
					},	0)					
				.fromTo(
					circle,
					duration*8,
					{						
						strokeDashoffset: burgerCircleLength+'px',
					},
					{
						strokeDashoffset: '0px',           
						ease: "expo.out",
					},	0)			
				.staggerFromTo(
					dLines,
					duration,
					{						
						strokeDashoffset: burgerLineLength+'px',
						x: -12,
						// opacity: 0,
						y: function(index) 
						{ 
							return (index % 2) == 0 ? -12 : 12
						},
					},
					{
						strokeDashoffset: '0px',
						x: 0,
						y: 0,   
						// opacity: 1,             
						ease: "power5.out",
					},
				stagger, dStart)       
				;  
				
				if (reverse == true){
					tl.reverse(0);
				} else {
					tl.play(0);
				}
       
			}
		}		

	},	

};

export default nav;
